import React, { useState } from "react";
import CPSideBarTabs from "../CPSideBarTabs";
import CPPCMeetingPickup from "./CPPCMeetingPickup";
import CPPCTourDetails from "./CPPCTourDetails";
import CPPCAgeGroup from "./CPPCAgeGroup";
import CPPCGuideLanguage from "./CPPCGuideLanguage";
import CPPCInclusionExclusion from "./CPPCInclusionExclusion";
import CPPCAccessibility from "./CPPCAccessibility";

// icons
import meetingIconWhite from "../../../../assets/cp-pc-meeting-icon-white.svg";
import meetingIconBlack from "../../../../assets/cp-pc-meeting-icon-black.svg";
import meetingIconYellow from "../../../../assets/cp-pc-meeting-icon-yellow.svg";
import tourIconWhite from "../../../../assets/cp-pc-tour-icon-white.svg";
import tourIconBlack from "../../../../assets/cp-pc-tour-icon-black.svg";
import tourIconYellow from "../../../../assets/cp-pc-tour-icon-yellow.svg";
import ageIconWhite from "../../../../assets/cp-pc-age-icon-white.svg";
import ageIconBlack from "../../../../assets/cp-pc-age-icon-black.svg";
import ageIconYellow from "../../../../assets/cp-pc-age-icon-yellow.svg";
import guideIconWhite from "../../../../assets/cp-pc-guide-icon-white.svg";
import guideIconBlack from "../../../../assets/cp-pc-guide-icon-black.svg";
import guideIconYellow from "../../../../assets/cp-pc-guide-icon-yellow.svg";
import inclusionIconWhite from "../../../../assets/cp-pc-inclusion-icon-white.svg";
import inclusionIconBlack from "../../../../assets/cp-pc-inclusion-icon-black.svg";
import inclusionIconYellow from "../../../../assets/cp-pc-inclusion-icon-yellow.svg";
import accessIconWhite from "../../../../assets/cp-pc-access-icon-white.svg";
import accessIconBlack from "../../../../assets/cp-pc-access-icon-black.svg";
import accessIconYellow from "../../../../assets/cp-pc-access-icon-yellow.svg";

function CPProductContent({
  setMainCurrentTab,
  mainCurrentTab,
  productDetail,
  categoryData,
  productId,
}) {
  const [activeTab, setActiveTab] = useState("meetingAndPickup");
  const sidebarItems = [
    {
      id: "meetingAndPickup",
      title: "Meeting & pickup",
      component: (
        <CPPCMeetingPickup
          setMainCurrentTab={setMainCurrentTab}
          setActiveTab={setActiveTab}
          productId={productId}
          productDetail={productDetail}
        />
      ),
      iconWhite: meetingIconWhite,
      iconYellow: meetingIconYellow,
      iconBlack: meetingIconBlack,
    },
    {
      id: "tourDetails",
      title: "Tour details",
      component: (
        <CPPCTourDetails
          setActiveTab={setActiveTab}
          productId={productId}
          productDetail={productDetail}
        />
      ),
      iconWhite: tourIconWhite,
      iconYellow: tourIconYellow,
      iconBlack: tourIconBlack,
    },
    {
      id: "ageGroup",
      title: "Age group",
      component: (
        <CPPCAgeGroup
          setActiveTab={setActiveTab}
          productDetail={productDetail}
          productId={productId}
        />
      ),
      iconWhite: ageIconWhite,
      iconYellow: ageIconYellow,
      iconBlack: ageIconBlack,
    },
    {
      id: "guideLanguage",
      title: "Guide & language",
      component: (
        <CPPCGuideLanguage
          setActiveTab={setActiveTab}
          productDetail={productDetail}
          productId={productId}
        />
      ),
      iconWhite: guideIconWhite,
      iconYellow: guideIconYellow,
      iconBlack: guideIconBlack,
    },
    {
      id: "inclusionsExclusions",
      title: "Inclusions & exclusions",
      component: (
        <CPPCInclusionExclusion
          setActiveTab={setActiveTab}
          productDetail={productDetail}
          productId={productId}
        />
      ),
      iconWhite: inclusionIconWhite,
      iconYellow: inclusionIconYellow,
      iconBlack: inclusionIconBlack,
    },
    {
      id: "accessibility",
      title: "Accessibility",
      component: (
        <CPPCAccessibility
          setMainCurrentTab={setMainCurrentTab}
          setActiveTab={setActiveTab}
          productDetail={productDetail}
          productId={productId}
        />
      ),
      iconWhite: accessIconWhite,
      iconYellow: accessIconYellow,
      iconBlack: accessIconBlack,
    },
  ];
  return (
    <div className="d-flex flex-md-row flex-column  align-items-start gap-3 mt-4  ">
      <CPSideBarTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        sidebarItems={sidebarItems}
        mainCurrentTab={mainCurrentTab}
        productDetail={productDetail?.data}
      />
      <div className="w-100">
        {sidebarItems.find((item) => item.id === activeTab)?.component}
      </div>
    </div>
  );
}

export default CPProductContent;
